// extracted by mini-css-extract-plugin
export var audioPlayer = "_kk-0";